import * as Factory from 'factory.ts'
import faker from 'faker'

import { type StripeAddress } from '../../models/StripeAddress'

export const StripeAddressMock = Factory.Sync.makeFactory<StripeAddress>({
  id: faker.random.number(),
  addressAssociation: faker.random.word(),
  addressLineOne: faker.address.streetAddress(),
  addressLineTwo: '',
  branch: faker.random.number(),
  city: faker.address.city(),
  country: faker.address.country(),
  created_at: faker.date.past(10).toISOString(),
  active: faker.random.boolean(),
  is_active: faker.random.boolean(),
  last_changed_by: faker.random.number(),
  name: faker.address.streetName(),
  postalCode: faker.address.zipCode(),
  state_province: faker.address.stateAbbr(),
  updated_at: faker.date.past(10).toISOString(),
})
